import { createApp } from 'vue';
import MediaBlock from './MediaBlock.vue';

import "./MediaBlock-entry.scss"

export default function mountMediaBlock() {

	const blocks = document.querySelectorAll('[data-feature="mediaBlock"]');

	blocks.forEach((block) => {
		const app = createApp({
			name: 'MediaBlockApp',
		});

		app.component('media-block', MediaBlock);
		app.mount(block);
	})
}

mountMediaBlock()